import { Select, Option } from "@mui/joy";

export type DateFilterValue =
    | "last7"
    | "last14"
    | "lastMonth"
    | "last90"
    | "last365"
    | "thisMonth"
    | "thisYear"
    | "allTime";

const dateFilters: { label: string; value: DateFilterValue }[] = [
    { label: "Last 7 Days", value: "last7" },
    { label: "Last 14 Days", value: "last14" },
    { label: "Last Month", value: "lastMonth" },
    { label: "Last 90 Days", value: "last90" },
    { label: "Last 365 Days", value: "last365" },
    { label: "This Month", value: "thisMonth" },
    { label: "This Year", value: "thisYear" },
    { label: "All Time", value: "allTime" },
];

interface DateFilterProps {
    selectedFilter: DateFilterValue;
    onChange: (value: DateFilterValue) => void;
}

interface DateFilterProps {
    selectedFilter: DateFilterValue;
    onChange: (value: DateFilterValue) => void;
    filterRange?: number;
}

export default function DateFilter({ selectedFilter, onChange, filterRange = dateFilters.length }: DateFilterProps) {
    return (
        <Select<DateFilterValue>
            size="sm"
            value={selectedFilter}
            onChange={(_, newValue) => newValue && onChange(newValue)}
            sx={{
                borderRadius: '10px',
                padding: '0 12px',
                height: '30px',
                backgroundColor: '#ffffff',
                fontSize: '12px',
            }}>
            {dateFilters.slice(0, filterRange).map(({ label, value }) => (
                <Option key={value} value={value}>
                    {label}
                </Option>
            ))}
        </Select>
    );
}